export const GET_ALL_REPORT_DISPLAY = 'GET_ALL_REPORT_DISPLAY'
export const GET_XLSX_FILE = 'GET_XLSX_FILE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_REPORT_TEMPLATES = 'GET_ALL_REPORT_TEMPLATES'
